import React from 'react';

/**
 * Unified auth chooser for LocalOps flows.
 * Renders:
 * - "Use Joe Galaxy Account" primary option
 * - Magic Link email option
 * Styling matches existing LocalOps auth surfaces.
 */
export default function AuthChooser({
  headerText,
  subText,
  primaryLabel = 'Use Joe Galaxy Account',
  primaryHelper1 = 'Recommended • Earn +1000 JGK bonus',
  primaryHelper2 = 'Faster access, saved history, bonus JGK for verified actions.',
  onPrimary,
  primaryDisabled = false,
  onPrimaryStart = () => {},
  email,
  onEmailChange,
  emailError,
  onEmailErrorClear = () => {},
  onSendMagicLink,
  magicStatus = 'idle',
}) {
  return (
    <div style={{ width: '100%' }}>
      {headerText ? (
        <div
          style={{
            marginBottom: 8,
            color: '#e8edf7',
            fontWeight: 700,
            fontSize: 15,
          }}
        >
          {headerText}
        </div>
      ) : null}
      {subText ? (
        <div
          style={{
            marginBottom: 10,
            color: '#9fb6d1',
            fontSize: 13,
          }}
        >
          {subText}
        </div>
      ) : null}

      <button
        type="button"
        className="loc-btn"
        disabled={primaryDisabled}
        onClick={() => {
          onPrimaryStart();
          if (onPrimary) onPrimary();
        }}
        style={{
          width: '100%',
          marginBottom: 10,
          padding: '12px 14px',
          borderRadius: 12,
          background:
            'linear-gradient(135deg, rgba(25,147,255,0.9), rgba(79,106,255,0.9))',
          color: '#fff',
          fontWeight: 800,
          border: 'none',
          opacity: primaryDisabled ? 0.65 : 1,
          cursor: primaryDisabled ? 'not-allowed' : 'pointer',
        }}
      >
        {primaryLabel}
        {primaryHelper1 ? (
          <div style={{ fontSize: 12, fontWeight: 500, opacity: 0.9 }}>
            {primaryHelper1}
          </div>
        ) : null}
        {primaryHelper2 ? (
          <div style={{ fontSize: 11, fontWeight: 500, opacity: 0.75 }}>
            {primaryHelper2}
          </div>
        ) : null}
      </button>

      <div
        style={{
          width: '100%',
          padding: '12px 14px',
          borderRadius: 12,
          background: 'rgba(255,255,255,0.04)',
          border: '1px solid rgba(255,255,255,0.08)',
          marginTop: 4,
        }}
      >
        <div style={{ marginBottom: 8, color: '#c6d5ef', fontWeight: 600 }}>
          Continue with Email (Magic Link)
        </div>
        <label
          htmlFor="magic-email"
          style={{
            display: 'block',
            fontSize: 12,
            color: '#8fa3c4',
            marginBottom: 6,
          }}
        >
          Email address (no password required)
        </label>
        <input
          id="magic-email"
          type="email"
          value={email}
          onChange={(e) => {
            onEmailChange?.(e.target.value);
            if (emailError) onEmailErrorClear();
          }}
          placeholder="you@example.com"
          autoComplete="email"
          spellCheck="false"
          style={{
            width: '100%',
            borderRadius: 10,
            border: `1px solid ${
              emailError ? 'rgba(255,99,99,0.7)' : 'rgba(255,255,255,0.18)'
            }`,
            background: 'rgba(255,255,255,0.06)',
            color: '#e8edf7',
            padding: '12px 12px',
            outline: 'none',
            fontSize: 14,
            marginBottom: 8,
          }}
        />
        {emailError ? (
          <div style={{ color: '#ff9b9b', fontSize: 12, marginBottom: 8 }}>
            {emailError}
          </div>
        ) : null}
        <button
          type="button"
          className="loc-btn secondary localops-btn"
          onClick={onSendMagicLink}
          disabled={magicStatus === 'sending'}
          style={{
            width: '100%',
            padding: '12px 14px',
            borderRadius: 12,
            background: 'linear-gradient(135deg, rgba(255,255,255,0.08), rgba(255,255,255,0.14))',
            color: '#e8edf7',
            border: '1px solid rgba(255,255,255,0.5)',
            fontWeight: 700,
          }}
        >
          {magicStatus === 'sending' ? 'Sending…' : 'Send magic link'}
          <div style={{ fontSize: 12, fontWeight: 500, opacity: 0.9 }}>
            We’ll email a one-time link to continue.
          </div>
        </button>
      </div>
    </div>
  );
}
